import React from 'react';
import Text, { Option, Select } from '../containers/Text';
import pad from 'pad-left';

const days = ['MON', 'TUE', 'WED', 'THU', 'FRI', 'SAT', 'SUN'];
const dayOptions = days.map((day, index) => {
  let dayName = `days.short.${day}`;

  if (day === days[new Date().getDay() - 1]) {
    dayName = 'days.today';
  }
  else if (day === days[new Date().getDay()]) {
    dayName = 'days.tomorrow';
  }
  return (<Option index={index} key={day} value={day} id={dayName} />)
})

/*
Start-of
Create an array of days for the select dropdown menu
Starting with: "Today, Tomorrow", day after tomorrow...
*/
const getTodayTomorrow = dayOptions.filter(day => day.key === (days[new Date().getDay()]) || (day.key === days[new Date().getDay() - 1]));

const getRestDays = dayOptions.filter(day => !(day.key === days[new Date().getDay()] || day.key === days[new Date().getDay() - 1]));

const dayOptionsOrdered = [...getTodayTomorrow, ...getRestDays];
const tomorrowIndex = dayOptionsOrdered[1].props.index;
const daysLeftThisWeek = 7 - (tomorrowIndex + 1); // 7-days week
const daysNewWeek = 5 - daysLeftThisWeek; //5 = 7- 2 (today/tomorrow)

let dayOptionsOrderedLogic = [];
for (let i = 0; i < daysLeftThisWeek; ++i) {
  dayOptionsOrderedLogic[i] = dayOptions[tomorrowIndex + 1 + i];
}
for (let i = 0; i < daysNewWeek; ++i) {
  dayOptionsOrderedLogic[daysLeftThisWeek + 1 + i] = dayOptions[i];
}
const dayOptionsOrderedFinal = [...getTodayTomorrow, ...dayOptionsOrderedLogic];
/* Start-of select dropdown menu */


const hours = [pad('00', 2, '0'), pad('01', 2, '0'), pad('02', 2, '0'), pad('03', 2, '0'), pad('04', 2, '0'), pad('05', 2, '0'), pad('06', 2, '0'), pad('07', 2, '0'), pad('08', 2, '0'), pad('09', 2, '0'), 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23];
const hourOptions = hours.map(hour => <option key={hour} value={hour}>{hour}</option>);
const minutes = [pad('00', 2, '0'), 15, 30, 45];
const minuteOptions = minutes.map(minute => <option key={minute}
  value={pad(minute, 2, '0')}>{pad(minute, 2, '0')}</option>);
const timePrep = ['UNTIL', 'BEFORE'];
const timePrepOptions = timePrep.map(el => <Option key={el} value={el} id={`time.preposition.${el}`} />);

class FilterOpenedAt extends React.Component {
  constructor(props) {
    super(props);

    // In case of debugging, just set a date like this:
    // const now = new Date('05.07.2017 23:46');
    const now = new Date();
    const m = Math.ceil(now.getMinutes() / 15) * 15;
    let hour = !!this.props.time ? pad(this.props.time.split(':')[0], 2, '0') : 18;
    let minute = !!this.props.time ? pad(this.props.time.split(':')[1], 2, '0') : '00';
    let day = !!this.props.day ? this.props.day : days[now.getDay() - 1];

    if (minute == 60) {
      hour++;
      minute = pad('00', 2, '0');

      if (hour == 24) {
        hour = pad('00', 2, '0');
        const currentDay = days.indexOf(day);
        day = currentDay + 1 > days.length ? days[0] : days[currentDay + 1];
      }
    }


    this.state = {
      enable: !!this.props.day && !!this.props.time,
      day, hour, minute
    };
  }


  handleChange(filter) {
    this.setState(Object.assign({}, this.state, {
      [filter.prop]: filter.value
    }));
  }

  render() {
    const handleChange = this.handleChange.bind(this);

    return (
      <div className="form-check filter-opened-at opening-container">
        <label className="form-check-label">
          <input
            id="openingHours"
            name="openingHours"
            className="form-check-input"
            type="checkbox"
            checked={this.state.enable}
            value="open"
            onChange={(e) => {
              handleChange({
                prop: 'enable',
                value: e.target.checked
              });
              this.props.onChange();
            }}
          />
          <Text id="time-filter.openedFilter" />
          <div className="select-wrapper">
            <Select
              label="search-details.select-day.label"
              aria-label="search-details.select-day.aria-label"
              id="selectedDay"
              value={this.state.day}
              className="form-control-sm"
              onChange={(e) => {
                handleChange({
                  prop: 'day',
                  value: e.target.value
                });
                if (this.state.enable) {
                  this.props.onChange();
                }
              }}
            >
              {dayOptionsOrderedFinal}
            </Select>
            <Select
              label="search-details.select-when.label"
              aria-label="search-details.select-when.aria-label"
              id="selectedTimeDiff"
              value={this.state.timePrep}
              className="form-control-sm"
              onChange={(e) => {
                handleChange({
                  prop: 'timePrep',
                  value: e.target.value
                });
                if (this.state.enable) {
                  this.props.onChange();
                }
              }}
            >
              {timePrepOptions}
            </Select>
            <Select
              label="search-details.select-hour.label"
              aria-label="search-details.select-hour.label"
              id="selectedHour"
              className="form-control-sm"
              value={this.state.hour}
              onChange={(e) => {
                handleChange({
                  prop: 'hour',
                  value: e.target.value
                });
                if (this.state.enable) {
                  this.props.onChange();
                }
              }}
            >
              {hourOptions}
            </Select>
            <Select
              label="search-details.select-minute.label"
              aria-label="search-details.select-minute.label"
              id="selectedMinute"
              className="form-control-sm"
              value={this.state.minute}
              onChange={(e) => {
                handleChange({
                  prop: 'minute',
                  value: e.target.value
                });
                if (this.state.enable) {
                  this.props.onChange();
                }
              }}
            >
              {minuteOptions}
            </Select>
            <Text id="time-filter.clock" />
          </div>
        </label>
      </div>
    );
  }
}

export default FilterOpenedAt;
